import { useCallback, useEffect, useState } from 'react';
import { z } from '@bonanza-social/toolkit/api';
import { Game } from '../state/shared/games.types';
import { DeviceType } from '../index.types';
import { GameplaySchema } from '../services/GameplayService/GameplayService.schemas';
import GameplayService from '../services/GameplayService/GameplayService';

const useGameplay = (
  id: Game['id'],
  deviceType: DeviceType,
  currencyCode?: string,
) => {
  const [data, setData] = useState<z.infer<typeof GameplaySchema>>({
    provider: '',
    url: '',
  });

  const fetch = useCallback(async () => {
    try {
      const data = await GameplayService.getGameplay({
        data: {
          gameId: id,
          isDemo: false,
          deviceType,
          currencyCode,
        },
      });

      setData(data);
    } catch (_) {
      // TODO: log error
    }
  }, [id, deviceType, currencyCode]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return data;
};

export default useGameplay;
